<template>
  <svg
    style="isolation:isolate"
    viewBox="0 0 200 200"
    width="0.6em"
    height="0.6em"
  >
    <path :fill="color" d=" M 0 100 L 100 0 L 200 100 L 100 200 L 0 100 Z "/>
  </svg>
</template>

<script>
export default {
  name: 'Pip',
  props: ['color'],
}
</script>
